import React, { FC, useState } from 'react'
import iconHelp from '../../../images/icons/icon-help.svg'
import * as Styled from './styled'

export const RegistrationFormHelpButton: FC = ({ children }) => {
  const [showMessage, setShowMessage] = useState<boolean>(false)
  return (
    <Styled.Button
      type="button"
      tabIndex={-1}
      onMouseEnter={() => {
        setShowMessage(true)
      }}
      onMouseLeave={() => {
        setShowMessage(false)
      }}
    >
      <Styled.Icon src={iconHelp} alt="Help" />
      {showMessage && (
        <Styled.HelpMessage>
          <div>{children}</div>
          <Styled.Arrow />
        </Styled.HelpMessage>
      )}
    </Styled.Button>
  )
}
